export const tradeResponseGetters = {
  tradeResponseHasResponse :state =>state.tradeResponseHasResponse,
  tradeResponseMerchantNotificationId:state =>state.tradeResponseMerchantNotificationId, //edit a single Item
  tradeResponseSelectedForEdit:state =>state.tradeResponseSelectedForEdit,
  tradeResponseIsEdit:state =>state.tradeResponseIsEdit,
  tradeResponseShowForm:state =>state.tradeResponseShowForm,
  tradeResponseId : state =>state.tradeResponseId,
  tradeResponsePageNumber : state =>state.tradeResponsePageNumber,
  tradeResponseItemsPerPage :state =>state.tradeResponseItemsPerPage,
  tradeResponseSelectedItem : state =>state.tradeResponseSelectedItem,
  tradeResponseCurrentList : state =>state.tradeResponseCurrentList,
  tradeResponseProp : state =>state.tradeResponseProp,
};
